"use client";

import { Typography, Card, Row, Col } from "antd";
import { SiteHeader, SiteFooter } from "@/widgets/site-layout";

const { Title, Paragraph, Text } = Typography;

const features = [
  {
    title: "Автоматический разбор DOCX",
    desc: "Система автоматически извлекает структуру документа: заголовки, параграфы, списки и разделы.",
    icon: "📄",
  },
  {
    title: "Интерактивные элементы",
    desc: "Таблицы, изображения, ссылки, сноски и вложения превращаются в кликабельные кнопки.",
    icon: "🖱️",
  },
  {
    title: "Модальные окна",
    desc: "Настраивайте способ отображения: модальное окно, боковая панель, аккордеон или новая страница.",
    icon: "🪟",
  },
  {
    title: "Брендинг компании",
    desc: "Логотип, цвета, шрифты и контактная информация — всё настраивается под ваш бренд.",
    icon: "🎨",
  },
  {
    title: "Поиск и оглавление",
    desc: "Полнотекстовый поиск и автоматическое оглавление для быстрой навигации.",
    icon: "🔍",
  },
  {
    title: "Экспорт HTML/PDF",
    desc: "Готовые файлы для публикации на сайте или распространения в PDF-формате.",
    icon: "📤",
  },
];

export default function FeaturesPage() {
  return (
    <>
      <SiteHeader />
      <main style={{ padding: "64px 24px", background: "#f5f5f5", flex: 1 }}>
        <div style={{ maxWidth: 1000, margin: "0 auto" }}>
          <Title level={1} style={{ textAlign: "center" }}>Возможности</Title>
          <Paragraph type="secondary" style={{ textAlign: "center", marginTop: 16 }}>
            Всё необходимое для превращения документов в интерактивный опыт
          </Paragraph>
          <Row gutter={[24, 24]} style={{ marginTop: 48 }}>
            {features.map((f) => (
              <Col xs={24} sm={12} lg={8} key={f.title}>
                <Card style={{ height: "100%" }}>
                  <span style={{ fontSize: 32 }}>{f.icon}</span>
                  <Title level={4} style={{ marginTop: 16 }}>{f.title}</Title>
                  <Text type="secondary">{f.desc}</Text>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </main>
      <SiteFooter />
    </>
  );
}
